import { useState } from 'react'
import { ApiUser } from '@vend/types'
import { useRegisterManager, useSaleManager } from '../../../../ng-compat/hooks'
import { convertApiUserToLineItemUser } from '../../../../models/user'
import { useAppDispatch, useAppSelector } from '../../../../state/hooks'
import { selectLoggedInUser } from '../../../../state/slices/posState/posStateSlice'
import {
  selectLineItems,
  updateLineItems,
} from '../../../../state/slices/currentSale/currentSaleSlice'

export interface SoldByMenuItemProps {
  onCompleted?: () => void
}

export const useSoldByMenuItemModel = (props: SoldByMenuItemProps) => {
  const dispatch = useAppDispatch()
  const lineItems = useAppSelector(selectLineItems)
  const saleManager = useSaleManager()
  const loggedInUser = useAppSelector(selectLoggedInUser)
  const users = useRegisterManager().getAllSelectableUsers()
  const isDisabled = users.length === 0

  // Popover state
  const [isPopoverOpen, toggleIsPopoverOpen] = useState<boolean>(false)
  const showPopover = () => {
    toggleIsPopoverOpen(true)
  }
  const hidePopover = () => {
    toggleIsPopoverOpen(false)
  }

  const onSelectHandler = (user: ApiUser) => {
    if (!user?.id) {
      hidePopover()
      return
    }

    const editableLineItems = lineItems.filter(lineItem => !lineItem.confirmed)
    if (!editableLineItems.length) {
      hidePopover()
      return
    }

    const lineItemUser = convertApiUserToLineItemUser(user)

    dispatch(
      updateLineItems(
        editableLineItems.map(lineItem => ({
          ...lineItem,
          salesperson: lineItemUser,
        }))
      )
    )
    saleManager.saveSale()
    hidePopover()
    props.onCompleted?.()
  }

  return {
    users,
    isDisabled,
    selectedUser: loggedInUser
      ? convertApiUserToLineItemUser(loggedInUser)
      : null,
    isPopoverOpen,
    showPopover,
    hidePopover,
    onSelectHandler,
  }
}
